import moment from "moment";

import { evaluate } from "./evaluate";
import { initScope } from "./initScope";

const MAX_TIME_IN_SECONDS = 1;
const MAX_TIME_IN_SECONDS_CREATION = 0.1;

export function generateScope(generationScript: string, seed?: number) {
  const scope = initScope(seed);

  const startTime = moment();
  const maxTime = window.location.pathname.startsWith("/creation")
    ? MAX_TIME_IN_SECONDS_CREATION
    : MAX_TIME_IN_SECONDS;

  do {
    if (moment().diff(startTime, "seconds", true) >= maxTime) {
      return {};
    }

    scope._check = true;
    evaluate(scope, generationScript);
  } while (!scope._check);

  return scope;
}
